import { LanguageInfo } from "./LanguageInfo";

export const availableLanguages = [
  "en",
  "de",
  "zh",
  "ko",
  "ru",
  "pl",
  "es",
  "ja",
  "fr",
  "ar",
  "vi",
  "sv",
  "no",
  "hi",
  "he",
  "fi",
  "nl",
];

const audioSupport = new Set<string>(availableLanguages);
audioSupport.delete("he"); // no hebrew...

export function isTextToSpeechSupported(language: LanguageInfo) {
  return audioSupport.has(language.code);
}
